import { useMemo, useReducer } from "react"
import { useParams } from "react-router-dom"

import { multipleDateRangeReducer } from "helpers/reducers/dateRangeReducer"
import useDevices from "helpers/hooks/useDevices"
import AlertsContext from "widgets/alerts/AlertsContext"
import AlertsTabView from "widgets/alerts/AlertsTabView"
import ActivityPanel from "widgets/alerts/ActivityPanel"
import NewAlertSettingButton from "widgets/alerts/settings/NewAlertSettingButton"
import Message from "widgets/common/Message"
import PowerlineAlertsContent from "widgets/powerlines/PowerlineAlertsContent"
import { BodyContainer } from "widgets/styled/containers"

const PowerlineAlerts = () => {
  const { id } = useParams()
  const { getLessIdFromPowerlineId } = useDevices()
  const [multipleDateRange, dispatchMultipleDateRange] = useReducer(
    multipleDateRangeReducer,
    {},
  )

  const virtualPowerlineId = useMemo(
    () => getLessIdFromPowerlineId(Number(id)),
    [getLessIdFromPowerlineId, id],
  )

  return (
    <AlertsContext.Provider
      value={{
        multipleDateRange,
        dispatchMultipleDateRange,
      }}
    >
      <BodyContainer disableGutters maxWidth="xl">
        <AlertsTabView
          tabsConfig={{
            configuredAlerts: <PowerlineAlertsContent />,
            activity: virtualPowerlineId ? (
              <ActivityPanel devicesIds={[virtualPowerlineId]} />
            ) : (
              <Message messageKey={"generic.NO_DATA_IN_TIME_WINDOW"} />
            ),
          }}
          actions={{
            configuredAlerts: (
              <NewAlertSettingButton entity="powerline" entityId={Number(id)} />
            ),
          }}
        />
      </BodyContainer>
    </AlertsContext.Provider>
  )
}

export default PowerlineAlerts
